// notification.component.ts
import { Component, OnInit } from '@angular/core';
import { NotificationService, Notification } from './notification.service';
import { PopupService } from 'src/app/modules/shared/_components/pricing-popup/popup.service';

@Component({
  selector: 'app-notification-banner',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {
  notification: Notification | null = null;
  timeoutRef: any;

  constructor(private notificationService: NotificationService, private popupService: PopupService) { }

  ngOnInit(): void {
    this.notificationService.notifications$.subscribe((notif) => {
      this.notification = notif;
      clearTimeout(this.timeoutRef);
      this.timeoutRef = setTimeout(() => this.notification = null, notif.duration || 10000);
    });
  }

  onUpgrade() {
    this.popupService.openPricingPopup();
  }

  dismiss() {
    this.notification = null;
  }
}
